import axios from '../http'
import {API} from "../const"

const api = API+'/mp';

export function getAuthUrl(params) {
    return axios.get(api+'/authorization-url',{params})
}

export function bindUser(code) {
    return axios.post(api+'/user-bind',null,{params:{code}})
}

export function bindWeiDian(code) {
    return axios.post(api+'/weidian-bind',null,{params:{code}})
}


export function unbindUser(code) {
    return axios.post(api+'/user-unbind',null,{params:{code}})
}
